

export interface IAuthenticationService {
  /**
   *@name updateAuthentication
   *@description search on server and update the authentication data
   * @param imei {string} - imei code for login
   * @param mac {string} - mac code for login
   * @param terminalId {string} - terminal code for login
   */
  updateAuthentication(imei: string, mac: string, terminalId: string): Promise<IAuthenticationDTO>;

  /**
   * @name authenticate
   * @description passing imei and mac address to validate if the device is linked with the stablishment
   * @param imei {string} - imei code for login
   * @param mac {string} - mac code for login
   * @param acquirer {AcquirerType} - acquirer type to handle configs from server
   * @param serial {string} - machine serial number for authentication
   */
  authenticate(imei: string, mac: string, acquirer: AcquirerType, serial?: string): Promise<IAuthenticationDTO>;
}


export interface IAuthenticationDTO {
    id: string;
    name: string;
    local: IAuthenticationLocalDTO;
    token: string;
  }
  
  export interface IAuthenticationLocalDTO {
    id?: string;
    name?: string;
    imageUrl?: string;
  }
  

  export enum AcquirerType {
    PAGARME = 1,
    STONE,
    PAGSEGURO,
    LINX,
    GETNET,
    CIELO,
  }




  export interface IAuthenticationServerResponse {
    localId: string;
    token: string;
    usuarioMeepPOSId: string;
    localNome: string;
    cidadeNome: string;
    corPrimaria: string;
    textoCorPrimaria: string;
    corPrimariaEscura: string;
    corSecundario: string;
    corSecundariaEscura: string;
    textoCorSecundario: string;
    appUrl: string;
    eCustomizado: boolean;
    usuarioMeepPOSApelido: string;
    endereco: string;
    cidade: string;
    dataVerificacaoAtualizacao: Date;
    trabalhaCreditoAluno: boolean;
    observacaoFicha: string;
    dadosLogin: string;
    identificarPagamento: boolean;
    endPointList: string;
    imprimirFichas: boolean;
    imprimirResumoPedido: boolean;
    urlBaseMeep200: string;
    pinCode: string;
    meep200: boolean;
    identificarClienteEstabelecimento: boolean;
    camposClienteEstabelecimento: string;
    aceitaParcelamento: boolean;
    gerarNfce: boolean;
    tokenClienteNfce: string;
    meepTotem: boolean;
    tipoSistema: number;
    tipoImpressao: number;
    tipoAdquirente: number;
    stoneCode: string;
    codigoCashless: string;
    userNamePagseguro: string;
    passwordPagseguro: string;
    buscarCartaoPorNome: boolean;
    cartaoMeep: boolean;
    cartaoRotativo: boolean;
    credito: boolean;
    debito: boolean;
    estaSenhaForteHabilitado: boolean;
    podeConsultarExtrato: boolean;
    recargaHabilitado: boolean;
    ativacaoHabilitado: boolean;
    desativacaoHabilitado: boolean;
    estaImpressaoComprovanteHabilitado: boolean;
    estaImpressoraRemotaHabilitada: boolean;
    chamarConfirmarPedidoAutomatico: boolean;
    solicitarCPFCartaoRotativo: boolean;
    abrirUltimaAcaoRealizada: boolean;
    abrirProdutoVariavelAutomatico: boolean;
    screenOrientation: number;
    codigoEstabelecimento: string;
    obrigarAtivacaoCartaoRotativo: boolean;
    labelCampoChaveParaAtivacaoCashless: string;
    aceitaPagarPedidoMeepFood: boolean;
    cnpj: string;
    uf: string;
  }
  